const sidebar = {
  communications: 'Communications',
  careCoordinator: 'Care Coordinator',
  patients: 'Patients',
  appointmentCalendar: 'Appointment Calendar',
  tasks: 'Tasks',
  reports: 'Billing',
  generalParameters: 'General Parameters',
  auditTimeLog: 'Audit Timelog',
  administration: 'Administration',
  inventory: 'Inventory',
  auditTimeLogApproval:'Timelog Approval '
}


export default sidebar
